<template>
  <div
      class="cws-container blog-wrapper"
  >

    <!-- content -->
    <div class="blog-detail-wrapper" v-if="playlistDetail">
      <b-row>
        <!-- blogs -->
        <b-col cols="12">
          <b-card
              _img-top
              _img-alt="Постер"
              _:title="`${playlistDetail.title}`"
          >
            <h1 class="d-flex">{{ playlistDetail.title }}
              <b-button
                  v-if="playlistDetail.url"
                  :href="playlistDetail.url"
                  variant="warning"
                  class="btn-icon ml-1"
                  size="sm"
              >
                <feather-icon icon="CastIcon"/>
              </b-button>
              <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="primary"
                  class="btn-icon ml-1"
                  size="sm"
                  :disabled="isLoadingPlaylist"
                  title="Сбросить кеш и загрузить заново"
                  @click="forceRefresh"
              >
                <feather-icon icon="RefreshCwIcon"/>
              </b-button>
            </h1>

            <b-row>
              <div
                  class="blog-content"
                  v-html="playlistDetail.description"
              />
            </b-row>
            
            <b-row>
              <b-col
                  cols="12"
                  md="12"
                  class="d-flex align-items-center justify-content-center mb-2 mb-md-0"
              >


                <b-card
                    :title="'Плейлист: ' + playlistDetail.title"
                    class="col-md-12 col-12"
                >
                  <b-overlay
                      :show="isLoadingPlaylist"
                      rounded="sm"
                  >
                    <b-row>
                      <b-col md="12">
                        <b-tabs
                            pills
                        >
                          <!-- Tab: Песни (таблица) -->
                          <b-tab>
                            <template #title>
                              <feather-icon
                                  icon="Share2Icon"
                                  size="16"
                                  class="mr-0 mr-sm-50"
                              />
                              <span class="d-none d-sm-inline">Песни [{{ playlistDetail.tracks.length }}]</span>
                            </template>

                            <div class="my-1 py-25">
                              <playlist-tracks-table
                                  :tracks="playlistDetail.tracks"
                                  :is-loading="isLoadingPlaylist"
                                  @add-track="addTrack"
                              />
                            </div>
                          </b-tab>

                        </b-tabs>
                      </b-col>
                    </b-row>
                  </b-overlay>
                </b-card>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
        <!--/ blogs -->
      </b-row>
      <!--/ blogs -->
    </div>
    <!--/ content -->

  </div>
</template>

<script>
import {
  BFormInput,
  BMedia,
  BAvatar,
  BMediaAside,
  BMediaBody,
  BImg,
  BLink,
  BFormGroup,
  BInputGroup,
  BInputGroupAppend,
  BCard,
  BRow,
  BCol,
  BBadge,
  BCardText,
  BDropdown,
  BDropdownItem,
  BForm,
  BFormTextarea,
  BFormCheckbox,
  BButton,
  BTab,
  BTabs,
  BSpinner,
  BOverlay,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import {badWord, formatNumber, formatDate} from '@core/utils/filter'
import router from "@/router";
import store from "@/store";
import musicStoreModule from "@/views/db-music/musicStoreModule";
import {onUnmounted, ref} from "@vue/composition-api";
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { isSubmissionResponse, notifySubmitted } from '@/libs/moderation'
import TrackRow from "@/views/db-music/TrackRow";
import PlaylistTracksTable from '@/views/db-music/PlaylistTracksTable.vue'
import {count} from "echarts/src/component/dataZoom/history";

export default {
  components: {
    TrackRow,
    PlaylistTracksTable,
    BFormInput,
    BMedia,
    BAvatar,
    BMediaAside,
    BMediaBody,
    BLink,
    BCard,
    BRow,
    BCol,
    BFormGroup,
    BInputGroup,
    BInputGroupAppend,
    BImg,
    BBadge,
    BCardText,
    BDropdown,
    BForm,
    BDropdownItem,
    BFormTextarea,
    BFormCheckbox,
    BButton,
    BTab,
    BTabs,
    BSpinner,
    BOverlay,
  },
  directives: {
    Ripple,
  },
  data() {
    return {}
  },
  methods: {
    count,
  },
  setup() {
    const STORE_MODULE_NAME = 'playlist'
    const toast = useToast()

    // Register module
    if (!store.hasModule(STORE_MODULE_NAME)) store.registerModule(STORE_MODULE_NAME, musicStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(STORE_MODULE_NAME)) store.unregisterModule(STORE_MODULE_NAME)
    })

    const playlistDetail = ref(null)
    const isLoadingPlaylist = ref(false)
    const disabledArtistId = ref(null)

    const fetchPlaylistData = async (refresh = false) => {
      let id = router.currentRoute.params.id
      let owner_id = router.currentRoute.params.owner_id
      let streaming = router.currentRoute.params.streaming

      if (streaming === 'yandex') {
        const res = await store.dispatch('playlist/yandexPlaylistView', {
          id,
          owner_id,
          queryParams: refresh ? {refresh: 1} : {},
        })
        playlistDetail.value = res.data
      } else if (streaming === 'spotify') {
        const res = await store.dispatch('playlist/spotifyPlaylistView', {
          id,
          owner_id
        })
        playlistDetail.value = res.data
      }
    }

    const addTrack = async (track) => {
      let artist_id = null
      let artist_name = null
      if (track && track.artists && track.artists[0] && track.artists[0].id) {
        artist_id = track.artists[0].id
      }
      if (track && track.artists && track.artists[0] && track.artists[0].name) {
        artist_name = track.artists[0].name
      }

      blockData()

      try {
        if (!artist_id) {
          const response = await store.dispatch(`playlist/createArtist`, {title: artist_name})
          let new_artist_id = response.data.data.id
          const addResponse = await store.dispatch('playlist/addTrack', {id: new_artist_id, queryParams: {title: track.title}})
          // Автор: трек ушёл на одобрение — данные не перезагружаем
          if (isSubmissionResponse(addResponse)) {
            notifySubmitted(toast)
            return
          }
          refreshData()
        } else {
          const addResponse = await store.dispatch('playlist/addTrack', {id: artist_id, queryParams: {title: track.title}})
          if (isSubmissionResponse(addResponse)) {
            notifySubmitted(toast)
            return
          }
          refreshData()
        }
      } catch (error) {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error adding track',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      } finally {
        unblockData()
      }
    }

    const forceRefresh = async () => {
      blockData()
      try {
        await fetchPlaylistData(true)
      } catch (error) {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error refreshing playlist data',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      } finally {
        unblockData()
      }
    }

    const refreshData = async () => {
      blockData()
      try {
        await fetchPlaylistData()
      } catch (error) {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error refreshing playlist data',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      } finally {
        unblockData()
      }
    }

    const blockData = () => {
      isLoadingPlaylist.value = true
    }

    const unblockData = () => {
      isLoadingPlaylist.value = false
    }

    fetchPlaylistData()

    return {
      formatDate,
      playlistDetail,
      isLoadingPlaylist,
      disabledArtistId,
      refreshData,
      forceRefresh,
      blockData,
      unblockData,
      formatNumber,
      addTrack,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-blog.scss';
</style>
